import React, { useState, useRef, useEffect } from 'react'
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { useHistory, useParams } from "react-router-dom";
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button,
    Input,
    Form
} from "reactstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import { callAPI } from "../../_helper/index";
import { Spinner } from 'reactstrap';
function ManageStore() {
    const [store, setStore] = useState({
        Id: 0,
        StoreName: '',
    })
    const [IsLoading, setIsLoading] = useState(false)
    const { id } = useParams();
    const { register, errors, handleSubmit } = useForm()
    const formRef = useRef(null)
    const history = useHistory();

    const onInputChange = (e) => {
       
        setStore({ ...store, [e.target.name]: e.target.value });
    };
    const handleClick = (e) => {
        e.preventDefault();
        formRef.current.props.onSubmit()
       
    };
    const onSubmit = () => {
        setIsLoading(true)
        var response = callAPI(`/api/stores`, "POST", JSON.stringify(store));
        response.then((res) => {
    
            if (res.success) {
                toast.success("Store saved!!!");
                setTimeout(() => {
                    setIsLoading(false)
                    history.push("/admin/store-master");
                }, 1000);
            } else {
                setIsLoading(false)
                toast.error(res.message);
            }
        });
    }

    useEffect(() => {

        if (id) {

            var response = callAPI(`/api/stores/${id}`, "GET", null);
            response.then((res) => {
               
                if (res.success) {

                    setStore(res.data[0])

                } else {
                    toast.error(res.message);
                }
            });


        }


    }, [id])

    const options = [
        {
            label: "ravisha",
            value: "ravisha",

        },
        {
            label: "sita",
            value: "sita",
        },
        {
            label: "mina",
            value: "mina",
        },
        {
            label: "test",
            value: "test",
        }
    ];

  

    return (
        <>
            <PanelHeader size="lg" />
            {
                IsLoading &&
                <div className="loader">
                    <Spinner color="white" />
                </div>
            }
            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card className="card-chart">
                            <CardHeader>
                                <CardTitle tag="h4">Store Management</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Form id="add_user" ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                                    <div className="new_user">
                                        {/* <input type="hidden" name="Id" value={store.Id} /> */}
                                        <Row>

                                            <Col xs={12} md={6}>
                                                <div className="form-group">
                                                    <label for="storename" className="text-dark">
                                                        Store Name:
                                                    </label>
                                                    <Input
                                                        type="text"
                                                        name="StoreName"
                                                        className="form-control"
                                                        placeholder="Medical Store"
                                                        value={store.StoreName}
                                                        onChange={(e) => onInputChange(e)}
                                                        innerRef={register({ required: true })}
                                                        invalid={errors.StoreName && true}
                                                    />
                                                </div>
                                            </Col>

                                        </Row>
                                        <div className="form-group">
                                            <Button
                                                type="submit"
                                                onClick={(e) => handleClick(e)}
                                                className="btn btn-info"
                                            >
                                                Save
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default ManageStore
